<script setup lang="ts">
import { computed } from 'vue';
import { defineProps } from 'vue';

// Define las propiedades que el componente aceptará
defineProps({
  title: {
    type: String,
    default: 'Fechas de las próximas revistas', // Título predeterminado
  },
  items: {
    type: Array,
    default: () => [], // Elementos predeterminados
  },
});


const defaultItems = [
    { titulo: 'Revista Orsai N. 12', contenido: '28 Feb, 2025' },
    { titulo: 'Revista Orsai N. 13', contenido: '14 May, 2025' },
    { titulo: 'Revista Orsai N. 14', contenido: '29 Jul, 2025' },
    { titulo: 'Revista Orsai N. 15', contenido: '13 Oct, 2025' },
    { titulo: 'Revista Orsai N. 16', contenido: '28 Dic, 2025' },
  ];

</script>

<template>
  <div class="collapse collapse-arrow bg-gray-100">
    <input type="checkbox" />
    <div class="collapse-title">
      <div class="flex items-center gap-2 font-medium text-sm md:text-base">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
        </svg>

        <span>{{ title }}</span>
      </div>
    </div>
    <div class="collapse-content">
      <div>
        <div
          v-for="(item, index) in (items.length ? items : defaultItems)"
          :key="index"
          class="flex items-center gap-2 justify-between py-2"
        >
          <span class="text-gray-800 font-medium">{{ item.titulo }}</span>
          <span class="text-gray-600">{{ item.contenido }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.size-6 {
  width: 1.5rem;
  height: 1.5rem;
}
</style>

